import { render, staticRenderFns } from "./IssuedDocumentListTable.vue?vue&type=template&id=593826fa&"
import script from "./IssuedDocumentListTable.vue?vue&type=script&lang=js&"
export * from "./IssuedDocumentListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports